import { ArticlesFormModel } from "./ArticlesFormModel";
import { emptyArticlesFormModelInitialState } from "../redux/articles-reducers";
import {
  ConditionsFormModel,
  emptyConditionsFormModel,
} from "./ConditionsFormModel";
import { emptyMatrixFormModel, MatrixFormModel } from "./MatrixFormModel";
import { emptyNotesFormModel, NotesFormModel } from "./NotesFormModel";
import { emptyRoutesFormModel, RoutesFormModel } from "./RoutesFormModel";

export interface RouteAgreementFormModel {
  articles: ArticlesFormModel;
  conditions: ConditionsFormModel;
  routes: RoutesFormModel;
  notes: NotesFormModel;
  matrix: MatrixFormModel;
}

export const emptyRouteAgreementFormModel: RouteAgreementFormModel = {
  articles: emptyArticlesFormModelInitialState,
  conditions: emptyConditionsFormModel,
  routes: emptyRoutesFormModel,
  notes: emptyNotesFormModel,
  matrix: emptyMatrixFormModel,
};
